// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";

import { getAuth, onAuthStateChanged } from "firebase/auth";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDRnQJHqcqmSH1YPhsNYYbvcJgwcbKne5I",
  authDomain: "prenotacampi-6b0fb.firebaseapp.com",
  projectId: "prenotacampi-6b0fb",
  storageBucket: "prenotacampi-6b0fb.appspot.com",
  messagingSenderId: "859596405748",
  appId: "1:859596405748:web:0f9b374f37ba8ab045d7a1",
  measurementId: "G-06M88YRRJZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export const db = getFirestore(app);

export const firebase = require('./firebase');

export const firebaseui = require('firebaseui');

export const auth = getAuth(app);

